import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar-chart-steps",
  "use": "icon-bar-chart-steps-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-bar-chart-steps\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bar-chart-steps\">\r\n  <path fill-rule=\"evenodd\" d=\"M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0z\" />\r\n  <rect width=\"5\" height=\"2\" x=\"2\" y=\"1\" rx=\".5\" />\r\n  <rect width=\"8\" height=\"2\" x=\"4\" y=\"5\" rx=\".5\" />\r\n  <path d=\"M6 9.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bar-chart-steps.svg
// module id = +f9y
// module chunks = 60